import { Injectable } from '@angular/core';
import { INDRAApiService } from '@ibe.services/api.indra.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MOCK_STATUS, URL_ANAC, MOCK_URL_ANAC } from '@ibe.config';
import { INDRAANACResponse, INDRAANACRequest } from '@ibe.models/atc.availability.indra.model.lib';

@Injectable({
	providedIn: 'root'
})
export class INDRAANACService {

	constructor(private api: INDRAApiService, private http: HttpClient) {
	}

	public INDRA_ANAC({from, to}: INDRAANACRequest): Observable<INDRAANACResponse> {
		if (MOCK_STATUS.ANAC) {
			return this.http.get<INDRAANACResponse>(MOCK_URL_ANAC);
		} else {
			return this.api.INDRA_get<INDRAANACResponse>(`${URL_ANAC}?from=${from}&to=${to}`);
		}
	}
}
